import * as React from 'react'

/* Import components here */
import { InvoiceTable } from 'components'
import { compose } from 'recompose'

import { withAuthorization, withEmailVerification } from '../../contexts'
export const InvoicesPage: React.FC = ({ children, ...props }) => {
  return (
    <div style={{ backgroundColor: 'white' }}>
      <InvoiceTable />
    </div>
  )
}

const condition = authUser => !!authUser

export default compose(withEmailVerification, withAuthorization(condition))(InvoicesPage)
